import type { ReactNode } from 'react'
import { BrandMark } from '@/components/BrandMark'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

interface AuthShellProps {
  title: string
  description?: ReactNode
  /** Labels which product surface this sign-in is for (e.g. "ops"). */
  brandSuffix?: string
  /** `md` for pages with more to show than a sign-in form (connecting an AI app, confirming an action). */
  size?: 'sm' | 'md'
  children: ReactNode
}

/** The centered card every signed-out page (sign in, reset, invitation) sits in. */
export function AuthShell({ title, description, brandSuffix, size = 'sm', children }: AuthShellProps) {
  return (
    <div
      data-density="compact"
      className="flex min-h-svh flex-col items-center justify-center gap-6 bg-canvas p-4 text-body text-foreground"
    >
      <BrandMark {...(brandSuffix ? { suffix: brandSuffix } : {})} />
      <Card className={size === 'md' ? 'w-full max-w-lg' : 'w-full max-w-sm'}>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {description ? <CardDescription>{description}</CardDescription> : null}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  )
}
